module.exports = __webpack_public_path__ + "static/media/Updates_for_UIL_Sightreading_1_6_23.e19672e6.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/2024/Updates_for_UIL_Sightreading_1_6_23.pdf
// module id = 217
// module chunks = 0